import React from "react";
import {
  bignumberCardStyle,
  goBignumberCardStyle,
  neutralBignumberCardStyle,
  type ClassificationLevel,
  type GoClassificationLevel,
} from "@shared/utils";

interface ClassificationBignumberCardProps {
  label: string;
  displayValue: string;
  level?: ClassificationLevel;
  goLevel?: GoClassificationLevel;
}

export const ClassificationBignumberCard: React.FC<ClassificationBignumberCardProps> = ({
  label,
  displayValue,
  level,
  goLevel,
}) => {
  const hasValue = displayValue !== "—";
  const styles =
    hasValue && (level || goLevel)
      ? goLevel !== undefined
        ? goBignumberCardStyle(goLevel)
        : bignumberCardStyle(level ?? "low")
      : neutralBignumberCardStyle();

  return (
    <div
      className={[
        "flex min-h-[92px] flex-1 flex-col items-center justify-between rounded-2xl border px-4 py-3 shadow-[1px_2px_8px_rgba(25,25,28,0.08)] transition-colors",
        styles.card,
      ].join(" ")}
    >
      <p className={["w-full text-center text-sm font-bold leading-snug", styles.title].join(" ")}>
        {label}
      </p>
      <p
        className={[
          "w-full text-center text-xl font-bold leading-normal",
          styles.label,
        ].join(" ")}
      >
        {displayValue}
      </p>
    </div>
  );
};
